import { Box, Stack } from '@mui/material';

import { MyTasks } from 'components/Dashboard/MyTasks';
import { DailySurvey } from 'components/Dashboard/DailySurvey';
import { PersonalImpactCalendar } from 'components/Dashboard/PersonalImpactCalendar';
import StudyOpportunityCard from 'components/Dashboard/StudyOpportunities';
import { MyData } from 'components/Dashboard/MyData';
import { RegistryDashboard } from 'components/Dashboard/RegistryDashboard';

const DashboardHome = () => {
  return (
    <Box
      sx={{
        padding       : { xs: '10px', md: '26px 78px' },
        display       : 'flex',
        flexDirection : 'column',
        maxWidth      : '1380px',
        margin        : 'auto',
      }}>
      <MyTasks />
      <Stack
        direction={{ xs: 'column', md: 'row' }}
        gap='52px'
        marginTop='57px'
        marginBottom='57px'
        minHeight='498px'>
        <DailySurvey />
        <PersonalImpactCalendar />
      </Stack>
      <RegistryDashboard />
      <StudyOpportunityCard />
      <MyData />
    </Box>
  );
};

export default DashboardHome;
